import { render, staticRenderFns } from "./Activity-mgmt.vue?vue&type=template&id=1993c4d2"
import script from "./Activity-mgmt.vue?vue&type=script&lang=js"
export * from "./Activity-mgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports